import './Banner2.css'
function ManoelBanner(){
    return(
        <div className="inicioManoel">
        <h1 className="textoManoel">Fotos do Cabeço</h1>
        <p className="textoManoel">Fotos do lugar onde Manoel cresceu e viveu</p>


    </div>

    )

    

}
export default ManoelBanner